import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import PageHeader from "../../components/PageHeader";
import PageFooter from "../../components/PageFooter";

export default function MainLayout(props) {
  return (
    <>
      <PageHeader />
      <PageContent>
        <Outlet />
      </PageContent>
      <PageFooter />
    </>
  );
}
const PageContent = styled.main`
  width: 100%;
  height: max-content;
`;
